import React, { Component } from "react";
import PropTypes from "prop-types";
import { Route } from 'react-router';
import { connect } from "react-redux";
import { siteDetailsInitOperation, checkIsCommingSoon } from 'sites/state/modules/common/operations';
import {
   isSiteInitedSelector,
   authUserSelector,
   siteInfoSelector,
   isLouisianaBlockedSelector,
   isFetchingLogoutSelector,
   isGlobalLoadingSelector,
} from 'sites/state/modules/common/selectors';
import Layout from 'common/layout';
import StateBlock from 'sites/views/block/state';
import { wrongDownloadModalSelector } from 'sites/state/modules/media-resources/selectors';
import { setWrongDownloadButtonModal } from 'sites/state/modules/media-resources/actions';
import WrongDownloadModal from 'sites/views/media-modules/wrong-download-modal';
import PageLoader from "common/components/modules/page-loading";
import Router from 'sites/routes/router';
import { push } from "connected-react-router";
import LayoutView from "./layout-view";

class Mixed extends Component {
   static propTypes = {
      authUser: PropTypes.object,
      isSiteInited: PropTypes.bool.isRequired,
      component: PropTypes.any,
      init: PropTypes.func.isRequired,
      siteInfo: PropTypes.object.isRequired,
      isLouisianaBlocked: PropTypes.bool,
      closeWrongModal: PropTypes.func,
      wrongDownloadModal: PropTypes.object,
      isFetchingLogout: PropTypes.bool,
      checkIsCommingSoon: PropTypes.func,
      location: PropTypes.object,
      goTo: PropTypes.func,
      isGlobalLoading: PropTypes.bool,
   };

   componentDidMount() {
      const {
         init,
         isSiteInited,
         authUser,
         siteInfo,
         checkIsCommingSoon,
      } = this.props;
      if(!isSiteInited){
         init();
      } else {
         checkIsCommingSoon({ user: authUser, site_info: siteInfo })
      }
   }


   render() {
      const {
         component: ChildComponent,
         isSiteInited,
         siteInfo,
         isLouisianaBlocked,
         wrongDownloadModal,
         closeWrongModal,
         isFetchingLogout,
         isGlobalLoading,
         ...rest
      } = this.props;


      if(this.props?.location?.pathname ===  Router.route('CONTACT_FORM').getCompiledPath() || this.props?.location?.pathname ===  Router.route('CONTACT_US').getCompiledPath()) {

         if(!this.props?.authUser && 'contact_form_for_non_members_turned_on' in siteInfo && !siteInfo?.contact_form_for_non_members_turned_on) {
            this.props?.goTo(Router.route('HOMEPAGE').getCompiledPath())
         }

      }

      if(isLouisianaBlocked){
         return (
            <StateBlock
               state='Louisiana'
               logo={ siteInfo.site_logo }
            />
         )
      }

      if(isFetchingLogout){
         return (
            <Layout>
               <div
                  className='w-full h-screen'
               >
                  <Layout.Content>

                     <PageLoader withLoader loaderColor='primary' />
                  </Layout.Content>
               </div>
            </Layout>
         )
      }

      return (
         <LayoutView
            isSiteInited={ isSiteInited }
            isGlobalLoading={ isGlobalLoading }
         >
            <Route
               { ...rest }
               render={ (matchProps) => {
                  return <ChildComponent { ...matchProps } />;
               } }
            />
            {
               wrongDownloadModal.isOpen && (
                  <WrongDownloadModal
                     header={ wrongDownloadModal.header }
                     body={ wrongDownloadModal.body }
                     closeModal={ closeWrongModal }
                     isLimited={ wrongDownloadModal.is_limited }
                     isDownloadLimitReached={ wrongDownloadModal.isDownloadLimitReached }
                  />
               )
            }
         </LayoutView>
      );
   }
}

const mapStateToProps = (state) => {
   return {
      authUser: authUserSelector(state),
      isSiteInited: isSiteInitedSelector(state),
      siteInfo: siteInfoSelector(state),
      isLouisianaBlocked: isLouisianaBlockedSelector(state),
      wrongDownloadModal: wrongDownloadModalSelector(state),
      isFetchingLogout: isFetchingLogoutSelector(state),
      isGlobalLoading: isGlobalLoadingSelector(state),
   };
}

const mapDispatchToProps = (dispatch) => ({
   init: () => {
      dispatch(siteDetailsInitOperation())
   },
   checkIsCommingSoon: (data) => {
      dispatch(checkIsCommingSoon(data))
   },
   closeWrongModal: (data) => dispatch(setWrongDownloadButtonModal(data)),
   goTo: (path, search) => {
      dispatch(push({
         pathname: path,
         search,
      }))
   },

});

export default connect(mapStateToProps, mapDispatchToProps)(Mixed);
